
import { Options, Vue } from "vue-class-component";
import AuthRedirect from "@/components/MAuthRedirect.vue";

@Options({
  components: {
    AuthRedirect
  }
})
export default class GoogleAuthRedirect extends Vue {}
